/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-disable no-unused-vars*/
import { Line } from 'react-konva';
import { strokeWidth, miniMapStrokeWidth } from '../../library/constants';
const relatedColor = 'black';

const TopOfGoalPost = ({ union, nodeObjs, startYOfHandle, unionIsRelated, minimap, stageBackgroundCustomColor }) => {
  const leftNodeObj = nodeObjs[union['p'][0]];
  const rightNodeObj = nodeObjs[union['p'][1]];

  const yGoalpostStart = leftNodeObj['bottom'];
  const xGoalpostStart = leftNodeObj['xCenter'];
  const xGoalpostEnd = rightNodeObj['xCenter'];

  const leftTopPost = [xGoalpostStart, yGoalpostStart];
  const leftBottomPost = [xGoalpostStart, startYOfHandle];
  const rightBottomPost = [xGoalpostEnd, startYOfHandle];
  const rightTopPost = [xGoalpostEnd, yGoalpostStart];
  const coordinates = [
    ...leftTopPost,
    ...leftBottomPost,
    ...rightBottomPost,
    ...rightTopPost,
  ];
  const color = typeof(stageBackgroundCustomColor) !== 'undefined' && stageBackgroundCustomColor === '#000000' ? '#FFFFFF': relatedColor;
  return (
    <Line
      points = {coordinates}
      stroke = {color}
      strokeWidth = {( typeof(minimap) !== 'undefined' ? miniMapStrokeWidth: strokeWidth)}
      lineCap = {'round'}
      perfectDrawEnabled={false}
      listening={false}
    />
  );
};

export default TopOfGoalPost;
